<div class="ui-g-12 text-right">
  <button
    pButton
    type="button"
    class="k-generic-btn"
    icon="fa fa-angle-left"
    iconPos="left"
    label="{{ 'common.back' | translate }}"
    (click)="goBack()">
  </button>
</div>
<div class="ui-g-12">
  <app-kontable
    title="{{ 'customers.accumulators' | translate }}"
    [columns]="[
      'channel_code',
      'acm_type',
      {field: 'acm_date_start', title: 'campaign.validityStartDate', type: 'date', filterType: dateFilter},
      {field: 'acm_date_end', title: 'campaign.validityEndDate', type: 'date', filterType: dateFilter},
      'acm_code',
      'acm_name',
      'operation_type',
      'value',
      'control_exp',
      'acm_scope'
    ]"
    [titles]="[
      'common.storeChannelLoyalty',
      'acm_type.acmType',
      'campaign.acmCode',
      'campaign.acmName',
      'campaign.operationType',
      'customers.value',
      'campaign.expression',
      'campaign.acmScope'
    ]"
    [source]="acmList"
    [showRecoverButton]="false"
    [showDetailsButton]="false"
    [showAddButton]="true"
    [showGlobalFilter]="false"
    [showInfoButton]="false"
    (onAdd)="showDialog()"
    (onEdit)="showDialog($event)"
    (onRemove)="deleteAcm($event)">
  </app-kontable>
</div>
<p-dialog
  *ngIf="showAddEditDialog"
  [(visible)]="showAddEditDialog"
  [modal]="true"
  [header]="dialogTitle"
  [minWidth]="700"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDialog()">
  <app-campaign-accumulators-form
    [messageInstance]="messageInstance"
    [acm]="acmToEdit"
    [channelList]="channelList"
    [acmTypeList]="acmTypeList"
    [operationTypeList]="operationTypeList"
    [acmScopeList]="acmScopeList"
    [actionStartDate]="actionStartDate"
    (onSave)="saveAcm($event)">
  </app-campaign-accumulators-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-accumulators/campaign-accumulators.component.html